import styled from "styled-components";

const LinkSpan = styled.span`
  display: block;
  font-size: 15px;
  text-transform: capitalize;
  font-weight: 400;
  letter-spacing: normal;

  @media (max-width: 575px) {
    font-size: 13px;
  }
`;
export default LinkSpan;
